<template>
  <div class="relative-position">
    <div
      v-if="label"
      class="text-weight-medium text-grey q-mb-sm"
    >
      {{ label }}
    </div>
    <q-input
      v-bind="attrs"
      ref="inputRef"
      no-error-icon
      :class="{ 'space-textarea-bottom': bottomCounter, 'disable': disable }"
      :disable="disable"
      @update:model-value="$emit('input', $event)"
      @blur="$emit('blur', $event)"
    >
      <template
        v-if="rightIcon"
        #append
      >
        <q-icon
          :name="rightIcon"
          class="fs-16"
        />
      </template>
      <template
        v-else
        #append
      >
        <slot name="append"/>
      </template>

      <template #prepend>
        <slot name="prepend"/>
      </template>
    </q-input>
    <div
      v-if="bottomCounter"
      :class="['textarea-counter absolute text-grey fs-12', { 'rules-position': attrs.rules }]"
    >
      {{ attrs.modelValue?.length || 0 }} / {{ maxCharacters }} {{ $t('text.characters') }}
    </div>
  </div>
</template>

<script setup>
import {
 useAttrs, computed, ref,
} from 'vue';

defineEmits(['input', 'blur']);

const attrs = useAttrs();

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  rightIcon: {
    type: String,
    default: null,
  },
  maxCharacters: {
    type: Number,
    default: null,
  },
  disable: {
    type: Boolean,
    default: false,
  },
});

const inputRef = ref(null);
const bottomCounter = computed(() => (attrs.type === 'textarea' && props.maxCharacters));

function focus() {
  inputRef.value.focus();
}

function validate() {
  return inputRef.value.validate();
}

function blur() {
  return inputRef.value.blur();
}

defineExpose({
  focus,
  validate,
  blur,
});
</script>

<style lang="scss">
.q-field--outlined .q-field__control {
  border-radius: 10px;
}

.q-field.disable {
  .q-field__inner {
    background: $grey-1;
    border-radius: 10px;
  }
}

.q-placeholder {
  &::placeholder {
    color: $grey !important;
    opacity: 1 !important;
  }
}

.q-textarea {
  .q-field__control {
    height: auto !important;
  }

  .q-field__native {
    appearance: none !important;
    line-height: 1 !important
  }
}

.textarea-counter {
  bottom: 10px;
  left: 12px;

  &.rules-position {
    bottom: 30px;
  }
}

.space-textarea-bottom {
  .q-field__control-container {
    padding-bottom: 32px;
  }
}
</style>
